import React, { useState } from "react";
import { Button, CircularProgress, Grid, Paper, TextField, Typography } from "@material-ui/core";
import { Formik, Form, ErrorMessage } from "formik";
import * as yup from "yup";
import { api } from "../../../api";
import { SnackBar } from "../../SnackBar";
import { ItemReturnVoucherList } from "./ItemReturnVoucherList";
import { useItemReturnStyles } from "../useItemReturnStyles";

export const ItemReturnVoucher = () => {
    const classes = useItemReturnStyles();
    const [voucherData, setVoucherData] = useState<Array<object>>([]);
    const [dataFlag, setDataFlag] = useState<boolean>(false);
    const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const showDetails = async (voucherCode: string) => {
        try {
            const result = await api.get(`item-return/${voucherCode}/items`)
            if (result !== undefined) {
                setVoucherData(result);
                setIsLoading(false);
                setDataFlag(true);
            }
        } catch (e) {
            setSnackbarColor("red");
            setErrorMessage("Something went wrong");
        }
    };

    const onCloseSnackbar = () => {
        setErrorMessage("");
    };

    return (
        <div className={classes.root}>
            <SnackBar
                status={errorMessage}
                onCloseError={onCloseSnackbar}
                color={snackbarColor}
            />
            <Paper elevation={2} className={classes.paper}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Formik
                            enableReinitialize
                            initialValues={{
                                returnVocherId: "",
                            }}
                            validationSchema={yup.object().shape({
                                returnVocherId: yup.string().required("Required")
                            })
                            }
                            onSubmit={async (values) => {
                                setIsLoading(true);
                                showDetails(values.returnVocherId);
                            }}
                        >
                            {({ values, handleChange }) => (
                                <Form>
                                    <Grid container direction="row" alignItems="center" spacing={1}>
                                        <Grid item xs={6}>
                                            <Grid container direction="column">
                                                <Typography style={{ textAlign: "left" }}>
                                                    Enter Return Voucher No
                                                 </Typography>
                                                <TextField
                                                    variant="outlined"
                                                    name="returnVocherId"
                                                    onChange={handleChange}
                                                    value={values.returnVocherId}
                                                />
                                                <ErrorMessage name="returnVocherId">
                                                    {(msg) => (
                                                        <div className={classes.textFieldErrorMessageStyle}>{msg}</div>
                                                    )}
                                                </ErrorMessage>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={3} sm="auto" style={{ paddingTop: "2em" }}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                type="submit"
                                                disabled={isLoading}>
                                                Show Return Details
                                            </Button>
                                            {isLoading && (
                                            <CircularProgress size={24} className={classes.circularProgress} />
                                            )}
                                        </Grid>
                                        <Grid item xs={3} sm="auto" style={{ paddingTop: "2em" }}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                type="reset"
                                                onClick={() => {
                                                    setDataFlag(false);
                                                    setVoucherData([]);
                                                    setIsLoading(false);
                                                }}>
                                                Clear
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Form>
                            )}
                        </Formik>
                        {dataFlag ? (
                            <Grid item xs={12} className={classes.tableStyles} >
                                <ItemReturnVoucherList
                                    voucherData={voucherData}
                                    getPrintDetails={() => { }}
                                    searchFlag={true}
                                />
                            </Grid>
                        ) : ""}
                    </Grid>
                </Grid>
            </Paper>
        </div>
    );
};